import { SpeciesType } from '@common/models/Enums';
import { ModelRecord } from '@common/models/Model';
import { ISyncModel, SyncModel } from '@common/models/SyncModel';

export interface IVisitPet extends ISyncModel {
  petId: number;
  name: string;
  speciesId: SpeciesType;
  speciesName: string;
  hasHadReaction: boolean;
  processedPhotoBaseUrl: string;
  photoUrl: string;
  azureImage: { container: string; fileName: string } | undefined;
}

export class VisitPetModel extends SyncModel implements ModelRecord<IVisitPet> {
  petId: number;
  name: string;
  speciesId: SpeciesType;
  speciesName: string;
  hasHadReaction: boolean;
  processedPhotoBaseUrl: string;
  photoUrl: string;
  azureImage: { container: string; fileName: string } | undefined;

  constructor(params: Partial<IVisitPet>) {
    super(params);
    this.petId = _.defaultTo(params.petId, 0);
    this.name = _.defaultTo(params.name, '');
    this.speciesId = _.defaultTo(params.speciesId, SpeciesType.Unknown);
    this.speciesName = _.defaultTo(params.speciesName, '');
    this.hasHadReaction = _.defaultTo(params.hasHadReaction, false);
    this.processedPhotoBaseUrl = _.defaultTo(params.processedPhotoBaseUrl, '');
    this.photoUrl = _.defaultTo(params.photoUrl, '');

    if (this.processedPhotoBaseUrl !== '') {
      // "processedPhotoBaseUrl": "/azure/pet/0-20240123210614-english-springer-spaniel-dog-breed-info.png"
      let url = this.processedPhotoBaseUrl.split('/');
      this.azureImage = {
        container: url[2],
        fileName: url[3],
      };
    }
  }
}
